import firebase from "firebase/compat/app";

/** The user document every client signup path creates. */
export const buildBaseUserDoc = ({ user, email, role, extra = {} }) => ({
  uid: user.uid,
  email: email || user.email || null,
  name: "",
  lastName: "",
  role,
  registrationDate: firebase.firestore.FieldValue.serverTimestamp(),
  onboarding: false,
  // [BETA-FORCE] Temporary: during the closed beta every new account is a beta
  // user. This is the single creation point for all client signup paths (share
  // link, self-signup, invited members, facility), so setting it here covers
  // everyone. Remove this line when the beta period ends so new accounts default
  // to non-beta again.
  betaAccess: true,
  ...extra,
});
